const actions = {
	
	FETCH_QR_BEGIN: 'FETCH_QR_BEGIN',
	FETCH_QR_SUCCESS: 'FETCH_QR_SUCCESS',
	FETCH_QR_ERR: 'FETCH_QR_ERR',

	fetchQrBegin: () => {
		return {
			type: actions.FETCH_QR_BEGIN,
		};
	},

	fetchQrSuccess: (data) => {
		return {
			type: actions.FETCH_QR_SUCCESS,
			data,
		};
	},

	fetchQrErr: (err) => {
		return {
			type: actions.FETCH_QR_ERR,
			err,
		};
	},

};

export default actions;
